<template>
  <div class="chart">
    <div id="ring-chart"></div>
    <div class="num">
      <div>验收率</div>
      <div>{{ hiddenScale }}%</div>
    </div>
  </div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import Highcharts3D from "highcharts/highcharts-3d";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);
Highcharts3D(Highcharts);
export default {
  name: "hiddenDangerHandleRing",
  components: {},
  props: {
    echartsData: {
      type: Object,
      default: {
        return: {},
      },
    },
  },
  data() {
    return {
      myChart: {},
      hiddenScale: "",
    };
  },
  created() {
    let _this = this;
    // window.onresize = function () {
    //   _this.myChart.reflow();
    // };
  },
  mounted() {
    this.$nextTick(() => {
      this.loadChart();
    });
  },
  computed: {},
  watch: {
    echartsData: function (newVal) {
      this.loadChart();
    },
  },
  methods: {
    loadChart() {
      let option = {
        chart: {
          type: "pie",
          margin: 0,

          backgroundColor: "rgba(0,0,0,0)",
          borderColor: "rgba(0,0,0,0)",
          options3d: {
            enabled: true,
            alpha: 60,
          },
        },
        colors: ["#1E4286", "#FFFF00"],
        title: {
          floating: true,
          useHTML: false,
          text: "",
        },
        tooltip: {
          enabled: false,
          pointFormat: "{point.percentage:.1f}%",
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false, // 是否显示版权信息
        },
        plotOptions: {
          pie: {
            innerSize: 100,
            depth: 14,
            dataLabels: {
              enabled: false,
              distance: -20,
              borderColor: "rgba(0,0,0,0)",
            },
          },
        },
        series: [
          {
            name: "整改信息",
            data: [],
          },
        ],
      };
      let data = [];
      let hiddenScale = this.echartsData.hiddenScale;
      this.hiddenScale = hiddenScale;
      data.push({
        name: "未整改",
        y: 100 - hiddenScale,
      });
      data.push({
        name: "已整改",
        y: hiddenScale,
      });
      option.series[0].data = data;
      var chart = Highcharts.chart("ring-chart", option);
    },
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.chart {
  height: 190px;
  text-align: center;
  position: relative;
  top: 2px;
  z-index: 5;
  .num {
    position: relative;
    top: 80px;
    div {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #eca800;
    }
  }
}
#ring-chart {
  width: 190px;
  height: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -95px;
}
</style>
